import Link from 'next/link'

const Pagination = ({
  next,
  previous,
}: {
  next?: string
  previous?: string
}): JSX.Element => {
  return (
    <div className="flex justify-between">
      <div>
        {previous && (
          <Link
            href={previous}
            className="order-first block border-2 bg-white text-goldenrod py-3 px-6 rounded-full text-center font-bold"
          >
            Previous Page
          </Link>
        )}
      </div>
      <div>
        {next && (
          <Link
            href={next}
            className="order-last block bg-goldenrod text-white border-2 border-goldenrod py-3 px-6 rounded-full text-center font-bold"
          >
            Next Page
          </Link>
        )}
      </div>
    </div>
  )
}

export default Pagination
